export const TRANSITION_DURATION = 300;
/** Above BottomMenu (z-index 60) so fullscreen/dialog overlays cover menu badges and “Новое сообщение” tips. */
export const Z_INDEX = 100;
